import React, { useState } from 'react';
import { Form, Input, Button, message, Card, Typography, Alert, Row, Col } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { changePassword } from '../services/authService';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './ChangePasswordPage.css';

const { Title } = Typography;

const ChangePasswordPage = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        setError(null);
        message.loading({ content: 'Passwort wird geändert...', key: 'changePass' });

        try {
            const response = await changePassword(values.currentPassword, values.newPassword);

            if (response.success) {
                message.success({ content: 'Passwort erfolgreich geändert!', key: 'changePass', duration: 3 });
                form.resetFields();
            } else {
                throw new Error(response.message || 'Passwort konnte nicht geändert werden.');
            }
        } catch (err) {
            console.error("Fehler bei Passwortänderung:", err);
            setError(err.message || 'Ein Fehler ist aufgetreten.');
            message.error({ content: `Fehler: ${err.message}`, key: 'changePass', duration: 5 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-5 change-password-page">
            <Helmet>
                <title>Passwort Ändern | Snus Finder</title>
                <meta name="description" content="Ändern Sie Ihr Passwort für Ihr Snus Finder Konto." />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <Row justify="center">
                <Col xs={24} sm={18} md={12} lg={8}>
                    <Card>
                        <Title level={2} style={{ textAlign: 'center', marginBottom: '2rem' }}>Passwort Ändern</Title>
                        <Form
                            form={form}
                            name="change_password"
                            onFinish={onFinish}
                            layout="vertical"
                            requiredMark={false}
                        >
                            <Form.Item
                                name="currentPassword"
                                label="Aktuelles Passwort"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Bitte geben Sie Ihr aktuelles Passwort ein!',
                                    },
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item
                                name="newPassword"
                                label="Neues Passwort"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Bitte geben Sie ein neues Passwort ein!',
                                    },
                                    {
                                        min: 6,
                                        message: 'Passwort muss mindestens 6 Zeichen lang sein!',
                                    },
                                ]}
                                hasFeedback
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item
                                name="confirmPassword"
                                label="Neues Passwort bestätigen"
                                dependencies={['newPassword']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'Bitte bestätigen Sie Ihr neues Passwort!',
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('newPassword') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Die beiden Passwörter stimmen nicht überein!'));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>

                            {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={loading} block>
                                    Passwort Ändern
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ChangePasswordPage;